import React, { useContext } from "react";
import { navigate } from "gatsby";
import { Button } from "../../../Button";
import { Headline } from "../../../Headline";

import t from "../../../../lib/translate";

import * as styles from "./langAside.module.less";
import { generateClassString as gcs } from "../../../../lib/helper/generateClassString";
import GeneralPageContext from "../../../../templates/GeneralPageContext";

export function LangAside() {
    const {
        locale: currentLocale,
        entryPage,
        localeVariants,
        domains
    } = useContext(GeneralPageContext);

    return (
        <div className={styles.langAside}>
            <Headline semanticOfHeadline={"H4"} hasLightBackground={true}>
                {t("navigation.language.switcher.caption")}
            </Headline>

            <div className={styles.langSelector}>
                <p>{t("navigation.language.switcher.region-placeholder")}</p>
                <select
                    name={"languageRegion"}
                    onChange={(event) => {
                        navigate(event.target.value);
                    }}
                    value={
                        domains.find(
                            ({ hreflang }) => hreflang === currentLocale
                        ).domain
                    }
                >
                    {domains.map(({ domain, name, hreflang }) => (
                        <option
                            key={`langOption-${hreflang}`}
                            className={styles.langSelector}
                            value={domain}
                        >
                            {name}
                        </option>
                    ))}
                </select>
            </div>
            <div className={styles.countrySelector}>
                <Button
                    key={`langButton-${currentLocale}`}
                    renderAs="link"
                    to={entryPage.url}
                    className={gcs(styles.regionPicker, styles.active)}
                    icon={`icon${currentLocale.replace("-", "").toUpperCase()}`}
                    iconPosition={"left"}
                    type={"secondary"}
                >
                    <span>{t(`lang-nav.option-${currentLocale}.label`)}</span>
                </Button>

                {localeVariants.map(({ locale, url }) => (
                    <Button
                        key={`langButton-${locale}`}
                        renderAs="link"
                        to={url}
                        className={styles.regionPicker}
                        icon={`icon${locale.replace("-", "").toUpperCase()}`}
                        iconPosition={"left"}
                        type={"secondary"}
                    >
                        <span>{t(`lang-nav.option-${locale}.label`)}</span>
                    </Button>
                ))}
            </div>
        </div>
    );
}
